import React from 'react';
import SEO from 'react-seo-component';

import './style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';

// Context
import { DeviceContext, deviceType } from '@providers';

// Components
// import DesktopStripBanners from '@src/componentsNew/Banner/DesktopStripBanner';
import DesktopSlideBanner from '@src/componentsNew/Banner/DesktopSlideBanner';
import DesktopHomePage from './DesktopHomePage';

// import MobileStripBanners from '@src/componentsNew/Banner/MobileStripBanner';
import MobileSlideBanner from '@src/componentsNew/Banner/MobileSlideBanner';
import MobileHomePage from './MobileHomePage';

// util
import { uiComponentVariables } from '@src/core/config';

function HomePage() {
  const { isMobile } = React.useContext<deviceType>(DeviceContext);
  const isComDomain = useIsComDomain();

  return (
    <div id="HomePageWrapper" className={`${isMobile ? (isComDomain ? 'mobile com' : 'mobile') : ''}`}>
      <SEO
        title={sessionStorage.getItem('headerText') || ''}
        titleTemplate={sessionStorage.getItem('shopName') || ''}
        titleSeparator={`-`}
        description={sessionStorage.getItem('description') || ''}
        image="/static/images/block1.png"
        pathname={sessionStorage.getItem('domainUrl') || ''}
        siteLanguage="en"
        siteLocale="en_GB"
        twitterUsername=""
      />

      {isMobile ? (
        <>
          {/* <MobileStripBanners /> */}
          <MobileSlideBanner
            uiComponentVariable={isComDomain ? uiComponentVariables.slideBannerCom : uiComponentVariables.slideBanner}
          />
          <MobileHomePage />
        </>
      ) : (
        <>
          {/* <DesktopStripBanners /> */}
          <DesktopSlideBanner
            uiComponentVariable={isComDomain ? uiComponentVariables.slideBannerCom : uiComponentVariables.slideBanner}
          />
          <DesktopHomePage />
        </>
      )}
    </div>
  );
}

export default HomePage;
